import RewardsPage from "./RewardsPage";

export default RewardsPage;
